import React, { useState } from 'react'

export type ScreenChecker = {
  _type: 'screenchecker'
  breakPoint: number
}

export default (checker: ScreenChecker) => {
  const [met, setMet] = useState(false)
  const query = `(max-width: ${checker.breakPoint}px)`
  const controller = new AbortController()

  React.useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setMet(event.matches)
    }

    const result = matchMedia(query)

    result.addEventListener('change', onChange, { signal: controller.signal })
    setMet(result.matches)

    return () => {
      controller.abort()
    }
  }, [query])

  return met
}
